'use client';

import { useEffect, useRef, useState } from 'react';

interface Props {
    children: React.ReactNode;
    cookiebotId?: string
}

export default function ConsentBlockerComponent({ children, cookiebotId }: Props) {
    const [consentGiven, setConsentGiven] = useState(true);
    // Traccia se il banner Cookiebot è stato mostrato all'utente in questo
    // caricamento pagina: solo in quel caso l'accept è una risposta "nuova"
    // e possiamo ricaricare senza rischiare loop di reload sugli utenti che
    // avevano già dato il consenso in una sessione precedente.
    const dialogShownRef = useRef(false);

    useEffect(() => {
        if (!cookiebotId) {
            setConsentGiven(true);
            return
        }

        const checkConsent = () => {
            if (window?.Cookiebot === undefined
                || (window?.Cookiebot && window.Cookiebot.hasResponse)) {
                setConsentGiven(true);
            } else {
                setConsentGiven(false);
            }
        };

        const onDialogDisplay = () => {
            dialogShownRef.current = true;
        };

        const onResponse = () => {
            checkConsent();
            // Ricarica solo se l'utente ha appena risposto tramite il banner
            // (evita reload per gli utenti che avevano già risposto).
            if (dialogShownRef.current) {
                window.location.reload();
            }
        };

        if (typeof window !== 'undefined') {
            window.addEventListener('CookiebotOnDialogDisplay', onDialogDisplay);
            window.addEventListener('CookiebotOnAccept', onResponse);
            window.addEventListener('CookiebotOnDecline', onResponse);
            checkConsent();
        }

        const interval = setInterval(() => {
            if (
                typeof window !== 'undefined' &&
                window?.Cookiebot?.hasResponse
            ) {
                setConsentGiven(true);
                clearInterval(interval);
            }
        }, 500);

        return () => {
            clearInterval(interval);
            window.removeEventListener('CookiebotOnDialogDisplay', onDialogDisplay);
            window.removeEventListener('CookiebotOnAccept', onResponse);
            window.removeEventListener('CookiebotOnDecline', onResponse);
        };
    }, []);

    return (
        <>
            {!consentGiven && (
                <div
                    style={{
                        position: 'fixed',
                        zIndex: 9999,
                        inset: 0,
                        backgroundColor: 'rgba(255,255,255,0.1)',
                        backdropFilter: 'blur(2px)',
                        cursor: 'not-allowed',
                        pointerEvents: 'all',
                    }}
                >
                    {/* eventualmente messaggio tipo "In attesa del consenso ai cookie..." */}
                </div>
            )}
            {children}
        </>
    );
}